import { type FC } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import Favorite from 'dibs-icons/exports/Favorite';

import dibsCss from 'dibs-css';
import styles from './SbSharedFavoritesNudgeToast.scss';

const SbSharedFavoritesNudgeToastContent: FC = () => (
    <div
        className={classNames(
            styles.toastContent,
            dibsCss.relative,
            dibsCss.zBump,
            dibsCss.bgWhite,
            dibsCss.pSmaller
        )}
    >
        <div className={classNames(dibsCss.flex, dibsCss.justifyBetween, dibsCss.gapSmaller)}>
            <div
                className={classNames(
                    styles.iconWrapper,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.justifyCenter,
                    dibsCss.roundedFull,
                    dibsCss.bgTangerine50,
                    dibsCss.fillWarningprimary
                )}
            >
                <Favorite variation="24" />
            </div>
            <div
                className={classNames(
                    dibsCss.flex,
                    dibsCss.flexCol,
                    dibsCss.gap2px,
                    dibsCss.maxW250px,
                    dibsCss.mrAuto
                )}
            >
                <span className={classNames(dibsCss.sassyFontBodySmallHeavy, dibsCss.textNoir)}>
                    <FormattedMessage
                        id="abf.SbSharedFavoritesNudgeToastContent.title"
                        defaultMessage="Save items you love"
                    />
                </span>
                <span className={classNames(dibsCss.sassyFontBodySmall, dibsCss.textCharcoal)}>
                    <FormattedMessage
                        id="abf.SbSharedFavoritesNudgeToastContent.body"
                        defaultMessage="Track price drops and get exclusive offers for your favorited items."
                    />
                </span>
            </div>
        </div>
    </div>
);

export { SbSharedFavoritesNudgeToastContent };
